import { Container, Grid } from "@mui/material";

import UploadFile from "./Component/UploadFile";
import Users from "./Component/Users";

export function ProfileMain() {
  return (
    <Container>
      <Grid container spacing={1}>
        <Users />

        <UploadFile />
      </Grid>
    </Container>
  );
}
export default ProfileMain;
